import { ExclamationCircleIcon } from '@heroicons/react/24/outline'

export function ErrorNote({ children }: { children?: string }) {
  if (!children) return null
  return (
    <div className='flex items-center w-full p-2 space-x-2 border rounded text-rose-600 border-error bg-error/[.10]'>
      <ExclamationCircleIcon className='inline-block w-5 h-5 stroke-2' />
      <span className='text-base text-rose-600'>{children}</span>
    </div>
  )
}
